import React from 'react'
import { Outlet } from 'react-router-dom'
import TopSec from '../../Components/BankCard/TopSec'

function BankCard() {
  return (
    <div>
      <TopSec/>
      <Outlet/>
    </div>
  )
}

export default BankCard